import { createContext, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { KamiSama } from '@taxdown/kami-sama';
import { UserData } from '@taxdown/kami-sama/dist/definition';
import { SamaDictionary } from '@taxdown/kami-sama/dist/kamiSama/definition';
import { fetchSagaAction } from 'Store/modules/core/actions';
import { SAVE_USER_DATA_TYPE } from 'Store/modules/validations/types';
import { routes } from 'Constants/routes';
import { SaveDataType } from 'Types/common';
import { KamiContextType, KamiProviderProps } from './types';

export const VALIDATION_START_SCREEN = 'personal_data_start_mx';
export const VALIDATION_END_SCREEN = 'deductions_endflow_mx';
export const VALIDATION_EXIT_ROUTE = routes.RESULT;

const KamiContext = createContext({} as KamiContextType);

export const KamiProvider = ({ children }: KamiProviderProps): JSX.Element | null => {
  const dispatch = useDispatch();
  const [instance, setInstance] = useState<KamiSama | null>(null);
  const [kamiData, setKamiData] = useState<UserData | null>(null);

  const saveData = ({ stage, next = false }: SaveDataType): void => {
    const data = instance?.getUserData();
    dispatch(fetchSagaAction(SAVE_USER_DATA_TYPE, { stage, data, next }));
  };

  const initKamiSama = ({
    userData: infoUser,
    forms: kamiForms,
  }: {
    userData: UserData;
    forms: SamaDictionary;
  }): void => {
    if (infoUser && kamiForms) {
      if (instance) {
        instance.setUserData(infoUser);
        setKamiData(infoUser);
        return;
      }
      setInstance(new KamiSama(infoUser, infoUser, kamiForms, undefined, VALIDATION_START_SCREEN));
    }
  };

  return (
    <KamiContext.Provider
      value={useMemo(
        () => ({
          kamiSama: instance,
          forms: instance?.getForm() ?? {},
          saveData,
          initKamiSama,
          kamiData,
        }),
        [instance]
      )}
    >
      {children}
    </KamiContext.Provider>
  );
};

export default KamiContext;
